<template>
    <div id="trainees">
        <v-container justify-start fluid>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-layout row wrap>
                        <v-flex xs4 ml-5>
                            <v-text-field label="Wyszukaj po Imię/Nazwisko/PESEL" v-model="searchTerm" @keydown.enter="doSearch"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-btn color="success" @click="doSearch">Szukaj</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-btn color="info" @click="addNew"  v-if="$can('do','POKO_Kursanci_Edycja')" style="float:right">Dodaj kursanta</v-btn>
                </v-flex>
                <v-flex xs12>
                    <v-data-table
                            :options.sync="pagination"
                            :items="items"
                            :loading="loading"
                            :server-items-length="totalResults"
                            :footer-props="{
                            itemsPerPageOptions:[20,50,100,200],
                  }"
                            :headers="headers">
                        <template v-slot:item.id="{item}">
                            <v-layout align-center>
                                <v-icon small class="mr-2" @click="editTrainee(item.id)" title="Edytuj" v-if="$can('do','POKO_Kursanci_Edycja')">fa-edit</v-icon>
                                <v-icon small @click="deleteTrainee(item.id)" title="Usuń" v-if="$can('do','POKO_Kursanci_Edycja')">fa-trash-alt</v-icon>
                            </v-layout>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
            <AddEditTrainee :visible="showAddTrainee" :id="selectedTraineeId" @close="closeAddPopup" />
        </v-container>
    </div>
</template>

<script>
    import {  mapActions } from "vuex";
    import { traineeService } from "@/services/";
    import swal from "sweetalert";
    import AddEditTrainee from "./AddEditTrainee";

    export default {
        name: "Trainees",
        data() {
            return {
                loading: true,
                showAddTrainee: false,
                selectedTraineeId: 0,
                totalResults: 0,
                items: [],
                pagination: {},
                searchTerm: '',
                headers: [
                    { text: 'Imię', sortable: true, align: 'left', value: 'name'},
                    { text: 'Nazwisko', sortable: true, align: 'left', value: 'surname'},
                    { text: 'Telefon', sortable: true, align: 'left', value: 'phone'},
                    { text: 'Miasto', sortable: true, align: 'left', value: 'city'},
                    { text: 'Firma', sortable: true, align: 'left', value: 'companyName' },
                    { text: 'Akcje', sortable: false, align: 'left', value: 'id'}
                ]
            }
        },
        components: {AddEditTrainee},
        methods: {
            ...mapActions("title", ["updateTitle"]),
            ...mapActions("alert", ["error", "success"]),
            addNew() {
                this.selectedTraineeId = 0
                this.showAddTrainee = true
            },
            editTrainee(id) {
                this.selectedTraineeId = id
                this.showAddTrainee = true
            },
            doSearch()
            {
                this.refreshTable();
            },
            deleteTrainee(id) {
                swal({
                    title: "Czy na pewno?",
                    text:
                        "Usuniecię kursanta, spowoduje wyczyszczenie jego wrażliwych danych i dodanie go do usuniętych kursantów!",
                    icon: "warning",
                    buttons: ["Nie", "Tak"],
                    dangerMode: true
                }).then(confirmed => {
                    if (confirmed) {
                        traineeService
                            .deleteTrainee(id)
                            .then(resp => {
                                if (resp.data == null || !resp.data.success) {
                                    throw "Błąd usuwania kursanta";
                                } else {
                                    this.success("Usunięto");

                                }
                            })
                            .catch(e => {
                                console.log(e);
                                this.error("Nie można usunąć kursanta");
                            });
                    }
                });
            },
            closeAddPopup() {
                this.showAddTrainee = false
                this.selectedTraineeId = 0
                this.refreshTable()
            },
            refreshTable()
            {
                this.loading = true

                this.requestClients().then(data=> {
                    this.items = data.data.result.items,
                        this.totalResults = data.data.result.totalCount
                    this.loading = false
                })
            },
            requestClients() {
                const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
                let sortValue = ''
                if(sortBy.length > 0)
                {
                  sortValue = sortBy[0]
                  if(sortDesc.length > 0)
                    sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
                }
                var req = traineeService.getAll({ query: this.searchTerm, page: page, limit: itemsPerPage, sorting: sortValue});
                return req.catch(()=> {
                    this.error("Błąd pobierania kursantów");
                });
            }
        },
        created() {
            this.updateTitle("Kursanci");
        },
        watch: {
            pagination: {
                handler() {
                    this.requestClients().then(data=> {
                        this.items = data.data.result.items,
                            this.totalResults = data.data.result.totalCount
                        this.loading = false
                    })
                },
                deep: true
            }
        }
    }
</script>

<style >

</style>